class CustomerOwnOrderIdInput
{
    constructor()
    {
        /**
         * Selector for the input element.
         * @type {string}
         */
        this._inputSelector = '.js-customer-own-order-id-input';

        /**
         * Selector for the hidden input element.
         * @type {string}
         */
        this._hiddenInputSelector = '.js-customer-own-order-id-input--hidden';

        /**
         * Reference to the input element(s).
         * @type {HTMLInputElement|null}
         */
        this._inputElement = null;

        /**
         * Reference to the hidden input element(s).
         * @type {HTMLInputElement|null}
         */
        this._hiddenInputElement = null;
    }

    /**
     * Initializes the component by selecting elements and setting up events.
     */
    init()
    {
        this._inputElement = document.querySelector(this._inputSelector);
        this._hiddenInputElement = document.querySelector(this._hiddenInputSelector);

        if (!this._inputElement || !this._hiddenInputElement) return;

        this.initEvents();
    }


    /**
     * Initializes event listeners for the input elements.
     */
    initEvents()
    {
        this.handleKeyUpEvent = this.handleKeyUpEvent.bind(this);

        this._inputElement.addEventListener('input', this.handleKeyUpEvent);
    }

    /**
     * Handles the keyup event on the input element.
     * Updates the hidden input element's value to match the input element's value.
     */
    handleKeyUpEvent()
    {
        this._hiddenInputElement.value = this._inputElement.value;
    }
}

(new CustomerOwnOrderIdInput).init();
